// Configuración temporal para el sistema de arquetipos
// Este archivo se puede eliminar cuando el backend esté listo

export const ARCHETYPE_CONFIG = {
    // Endpoints del backend (cuando estén disponibles)
    ENDPOINTS: {
        QUESTIONS: 'users/archetype-quiz/questions',
        SUBMIT: 'users/archetype-quiz',
        GET_USER_ARCHETYPE: 'users/archetype',
        GET_ALL_ARCHETYPES: 'users/archetypes',
        GET_ARCHETYPE_BY_ID: 'users/archetypes'
    },

    // Configuración temporal
    TEMP: {
        // Si el backend no está disponible, usar datos mock
        USE_MOCK_DATA: false,

        // Simular delay de red
        NETWORK_DELAY: 0,

        // Mensajes de error amigables
        ERROR_MESSAGES: {
            QUESTIONS_NOT_AVAILABLE: 'Error al cargar las preguntas del cuestionario',
            SUBMIT_NOT_AVAILABLE: 'Error al procesar el cuestionario',
            ARCHETYPE_NOT_AVAILABLE: 'Error al cargar el perfil del usuario'
        }
    },

    // Configuración de UI
    UI: {
        // Tiempo de transición entre preguntas (ms)
        QUESTION_TRANSITION_DELAY: 300,

        // Tiempo de animación de carga (ms)
        LOADING_ANIMATION_DURATION: 1000,

        // Número máximo de reintentos
        MAX_RETRIES: 3
    }
};

// Función para verificar si el backend está disponible
export const isBackendAvailable = async () => {
    try {
        const response = await fetch('/api/health', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.ok;
    } catch (error) {
        console.warn('Backend not available:', error.message);
        return false;
    }
};

// Función para simular delay de red
export const simulateNetworkDelay = (ms = ARCHETYPE_CONFIG.TEMP.NETWORK_DELAY) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}; 